
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1pYOd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::99730993d4263175d62f8db387d720e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10874b9e5ca41beb$var$_react = $10874b9e5ca41beb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $10874b9e5ca41beb$var$_baseNew = $10874b9e5ca41beb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $10874b9e5ca41beb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-expand
 * Usage guidance:
 * Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10874b9e5ca41beb$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $10874b9e5ca41beb$var$_react.default.createElement($10874b9e5ca41beb$var$_baseNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$10874b9e5ca41beb$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $10874b9e5ca41beb$var$_default = module.exports.default = $10874b9e5ca41beb$var$SidebarExpandIcon;

});


//# sourceMappingURL=sidebar-expand.67ee0ac2.js.map
